// extracted by mini-css-extract-plugin
export default {"placeholderContainer":"omnibar-placeholder-module__placeholderContainer--H3A9_","placeholderText":"omnibar-placeholder-module__placeholderText--V7BOr"};